"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconVideo = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconVideo = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M9 7v9.818l7.636-4.909z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.939 24A12.065 12.065 0 0024 11.938a12.06 12.06 0 00-3.532-8.529A12.062 12.062 0 003.41 20.466 11.981 11.981 0 0011.939 24zm0-22.376c5.687 0 10.314 4.627 10.314 10.314s-4.627 10.314-10.314 10.314c-5.688 0-10.315-4.627-10.315-10.314S6.25 1.624 11.939 1.624z"
}));
exports.IconVideo = IconVideo;
//# sourceMappingURL=IconVideo.js.map